import PropTypes from 'prop-types'
import { useState } from 'react'
import { Box, Button, ButtonGroup, Flex, IconButton, Text } from '@chakra-ui/react'
import { MdAdd, MdDeleteOutline, MdOutlineArrowDropDown, MdOutlineArrowRight, MdOutlineEdit } from 'react-icons/md'
import { ProjectSectionTaskRow } from './ProjectSectionTaskRow'
import { TASK_STATUSES } from './ProjectTasks'

export const ProjectSectionRow = ({
  section,
  onEditSection,
  onRemoveSection,
  onAddTask,
  onEditTask,
  onRemoveTask,
  reload,
  onOpenTaskNotes,
  filterTaskStatus,
  ...rest
}) => {
  const [isExpanded, setIsExpanded] = useState(true)

  return (
    <Box
      position="relative"
      {...rest}
    >
      <Flex
        alignItems="center"
        height="40px"
        gap={2}
        onClick={() => setIsExpanded(!isExpanded)}
        borderBottomWidth={1}
        borderBottomStyle="solid"
        borderBottomColor="gray.200"
        _hover={{ bg: 'gray.100', cursor: 'pointer' }}
      >
        {isExpanded ? (
          <MdOutlineArrowDropDown fontSize="24px" />
        ) : (
          <MdOutlineArrowRight fontSize="24px" />
        )}
        <Text fontSize="sm" fontWeight="bold">{section.title}</Text>
      </Flex>
      <ButtonGroup position="absolute" top={1} right={2}>
        <IconButton
          variant="ghost"
          size="sm"
          colorScheme="gray"
          icon={<MdOutlineEdit fontSize="18px" />}
          onClick={() => onEditSection(section)}
        />
        <IconButton
          variant="ghost"
          size="sm"
          colorScheme="gray"
          icon={<MdDeleteOutline fontSize="18px" />}
          onClick={() => onRemoveSection(section)}
        />
      </ButtonGroup>
      {isExpanded && (
        <Box>
          {section.tasks.map(task => {
            switch (filterTaskStatus) {
              case TASK_STATUSES.All:
                break
              case TASK_STATUSES.Complete:
                if (task.isCompleted !== 1) {
                  return null
                }
                break
              case TASK_STATUSES.Incomplete:
                if (task.isCompleted !== 0) {
                  return null
                }
                break
            }
            return (
              <ProjectSectionTaskRow
                key={task.id}
                task={task}
                onEditTask={onEditTask}
                onRemoveTask={onRemoveTask}
                reload={reload}
                onOpenTaskNotes={onOpenTaskNotes}
                showProjectName={false}
              />
            )
          })}
          <Button
            ml={4}
            mt={2}
            mb={1}
            size="sm"
            variant="ghost"
            leftIcon={<MdAdd fontSize="18px" />}
            onClick={() => onAddTask(section.id)}
          >
            Add Task
          </Button>
        </Box>
      )}
    </Box>
  )
}

ProjectSectionRow.propTypes = {
  section: PropTypes.object,
  onEditSection: PropTypes.func,
  onRemoveSection: PropTypes.func,
  onAddTask: PropTypes.func,
  onEditTask: PropTypes.func,
  onRemoveTask: PropTypes.func,
  reload: PropTypes.func,
  onOpenTaskNotes: PropTypes.func,
  filterTaskStatus: PropTypes.string
}
